import appSettings from "~/appSettings";

import { Registration } from "../../client";

const id = appSettings.marketing.clarityId;

export default async (): Promise<Registration.Analytics> => {
  if (!id) return;

  const Clarity = (await import("@microsoft/clarity")).default;

  Clarity.init(id);

  return {
    identify({ userId, properties }) {
      if (userId) Clarity.identify(userId);
      if (properties) {
        for (const [key, value] of Object.entries(properties)) {
          Clarity.setTag(key, value);
        }
      }
    },
    track(name) {
      Clarity.event(name);
    },
    anonymize() {
      Clarity.identify("", undefined, undefined, undefined);
    },
  };
};
